export const FETCH_EVENT_REQUEST = 'events/event/FETCH_REQUEST';
export const FETCH_EVENT_SUCCESS = 'events/event/FETCH_SUCCESS';
export const FETCH_EVENT_FAILURE = 'events/event/FETCH_FAILURE';
export const FETCH_EVENTS_REQUEST = 'events/FETCH_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'events/FETCH_SUCCESS';
export const FETCH_EVENTS_FAILURE = 'events/FETCH_FAILURE';
export const NEXT_EVENTS_PAGE = 'events/NEXT_PAGE';

export const RESET = 'events/RESET';


// WEBPACK FOOTER //
// ./src/modules/events/actionTypes.js